/* "Ask about this wine" (snippets/pw-ask.liquid) and "Ask Primal" (snippets/pw-ask-drawer.liquid).
   Each [data-pw-ask] panel keeps its conversation in memory and posts it to the primal-ask Worker; a panel
   with data-handle is about that product, one without is the site-wide assistant. Add to cart reuses the
   theme's drawer refresh. The search bar gets an "Ask Primal" row when the text reads like a question. */
(function () {
  if (window.pwAsk) return; // loaded by both snippets
  var MAX_TURNS = 20;
  var FREE_SHIP_CENTS = 19900; // free ground shipping threshold, same as the cart offer

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  // Text with https://primalwine.com/... links made clickable. Built from text nodes, never innerHTML.
  function linked(tag, cls, text) {
    var p = el(tag, cls);
    var re = /https:\/\/(?:www\.)?primalwine\.com\/[^\s)]*[^\s).,;:!?]/g;
    var last = 0, m;
    while ((m = re.exec(text))) {
      p.appendChild(document.createTextNode(text.slice(last, m.index)));
      var a = el('a', 'pw-ask__link', m[0].replace(/^https:\/\/(?:www\.)?primalwine\.com/, ''));
      a.href = m[0];
      p.appendChild(a);
      last = m.index + m[0].length;
    }
    p.appendChild(document.createTextNode(text.slice(last)));
    return p;
  }

  function refreshCart() {
    var drawer = document.getElementById('site-cart-sidebar');
    if (drawer && !document.body.classList.contains('template-cart')) drawer.show();
    return fetch('?section_id=helper-cart').then(function (r) { return r.text(); }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var form = document.getElementById('AjaxCartForm');
      var src = doc.getElementById('AjaxCartForm');
      if (form && src) { form.innerHTML = src.innerHTML; if (form.ajaxifyCartItems) form.ajaxifyCartItems(); }
      var sub = document.getElementById('AjaxCartSubtotal');
      var subSrc = doc.getElementById('AjaxCartSubtotal');
      if (sub && subSrc) sub.innerHTML = subSrc.innerHTML;
      var count = doc.querySelector('[data-cart-count]');
      var total = doc.querySelector('[data-cart-total]');
      document.querySelectorAll('[data-header-cart-count]').forEach(function (n) { if (count) n.textContent = count.textContent; });
      document.querySelectorAll('[data-header-cart-total]').forEach(function (n) { if (total) n.textContent = total.textContent; });
      var c = count ? parseInt(count.textContent, 10) : 0;
      if (window.pwAnnounce) window.pwAnnounce('Added to cart.' + (c ? ' Shopping cart, ' + c + (c === 1 ? ' item.' : ' items.') : ''));
    });
  }

  function init(root) {
    if (root._pwAsk) return root._pwAsk;
    var log = root.querySelector('[data-pw-ask-log]');
    var form = root.querySelector('[data-pw-ask-form]');
    var input = form.querySelector('input');
    var send = form.querySelector('button');
    var chips = root.querySelector('[data-pw-ask-chips]');
    var reset = root.querySelector('[data-pw-ask-reset]');
    var turns = [];
    var busy = false;
    var gen = 0;

    function say(cls, text) {
      var p = linked('p', 'pw-ask__msg ' + cls, text);
      log.appendChild(p);
      return p;
    }

    // Adds variants to the cart in one /cart/add.js call, then opens the drawer. Resolves true on success.
    function addToCart(items) {
      // The site-wide assistant is a modal dialog: close it so the cart drawer is reachable.
      var dlg = root.closest('dialog');
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        if (dlg && dlg.open) dlg.close();
        return refreshCart().then(function () { return true; });
      });
    }

    function card(w) {
      var li = el('li', 'pw-ask__card');
      var img = el('img', 'pw-ask__img');
      img.src = w.image; img.alt = ''; img.width = 80; img.height = 80;
      var ph = el('span', 'pw-ask__ph'); ph.appendChild(img);
      var body = el('div', 'pw-ask__card-body');
      var a = el('a', 'pw-ask__card-title', w.title);
      a.href = w.url;
      body.appendChild(a);
      body.appendChild(el('span', 'pw-ask__card-price', w.price));
      var btn = el('button', 'button button--solid pw-ask__add');
      btn.type = 'button';
      btn.appendChild(el('span', 'button__text', 'Add to cart'));
      btn.setAttribute('aria-label', 'Add to cart, ' + w.title);
      btn.addEventListener('click', function () {
        btn.disabled = true;
        addToCart([{ id: w.variant_id, quantity: 1 }]).catch(function () {
          say('pw-ask__msg--error', 'That bottle could not be added. Open its page to try again.');
        }).then(function () { btn.disabled = false; });
      });
      li.appendChild(ph);
      li.appendChild(body);
      li.appendChild(btn);
      return li;
    }

    // "Add all N to cart, $X": the Worker sends a case when the cards are bottles to buy together.
    // Disabled after it succeeds, so a second press cannot double the case.
    function caseBox(c, wines) {
      var box = el('div', 'pw-ask__case');
      var btn = el('button', 'button button--solid pw-ask__case-add');
      btn.type = 'button';
      var label = el('span', 'button__text', 'Add all ' + c.count + ' to cart, ' + c.total);
      btn.appendChild(label);
      btn.addEventListener('click', function () {
        btn.disabled = true;
        addToCart(wines.map(function (w) { return { id: w.variant_id, quantity: 1 }; })).then(function () {
          label.textContent = 'Case added to cart';
        }).catch(function () {
          btn.disabled = false;
          say('pw-ask__msg--error', 'The case could not be added. A bottle may have just sold out: add the bottles one at a time.');
        });
      });
      box.appendChild(btn);
      if (c.total_cents >= FREE_SHIP_CENTS) box.appendChild(el('p', 'pw-ask__case-note', 'This case qualifies for free ground shipping (orders of $199 or more).'));
      return box;
    }

    function ask(q) {
      q = (q || '').trim().slice(0, 500);
      if (!q || busy) return;
      if (turns.length >= MAX_TURNS - 1) {
        say('pw-ask__msg--error', 'This conversation has reached its limit. Choose Start over to begin a new one.');
        return;
      }
      busy = true;
      send.disabled = true;
      chips.hidden = true;
      reset.hidden = false;
      say('pw-ask__msg--you', q);
      turns.push({ role: 'user', content: q });
      input.value = '';
      var wait = say('pw-ask__msg--wait', 'Writing an answer…');
      var mine = gen;
      var body = { messages: turns };
      if (root.dataset.handle) body.handle = root.dataset.handle;
      fetch(root.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (d) { return { status: r.status, d: d }; });
      }).then(function (res) {
        if (mine !== gen) return;
        wait.remove();
        if (res.status !== 200) {
          turns.pop();
          var msg = res.status === 429 ? 'Too many questions in a minute. Wait a moment and ask again.'
            : res.status === 503 ? 'The assistant is off for today. Use the search bar, or the Contact page and our team will answer.'
            : 'Something went wrong. Ask again in a moment.';
          say('pw-ask__msg--error', msg);
          return;
        }
        var reply = res.d.reply.slice(0, 2000);
        turns.push({ role: 'assistant', content: reply });
        say('pw-ask__msg--bot', reply);
        if (res.d.wines && res.d.wines.length) {
          var ul = el('ul', 'pw-ask__cards');
          ul.setAttribute('aria-label', 'Suggested wines');
          res.d.wines.forEach(function (w) { ul.appendChild(card(w)); });
          log.appendChild(ul);
          if (res.d.case) log.appendChild(caseBox(res.d.case, res.d.wines));
        }
      }).catch(function () {
        if (mine !== gen) return;
        wait.remove();
        turns.pop();
        say('pw-ask__msg--error', 'Something went wrong. Ask again in a moment.');
      }).then(function () {
        if (mine !== gen) return;
        busy = false;
        send.disabled = false;
      });
    }

    // Start over: clear the conversation and bring back the suggested questions. A request still in flight
    // is dropped when it returns (gen changes), so its answer cannot land in the new conversation.
    function clear() {
      gen++;
      turns = [];
      log.textContent = '';
      busy = false;
      send.disabled = false;
      chips.hidden = false;
      reset.hidden = true;
      input.value = '';
    }
    reset.addEventListener('click', function () {
      clear();
      chips.querySelector('.pw-ask__chip').focus();
      if (window.pwAnnounce) window.pwAnnounce('Conversation cleared.');
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); ask(input.value); });
    chips.addEventListener('click', function (e) {
      var b = e.target.closest('.pw-ask__chip');
      if (b) { ask(b.textContent); input.focus(); }
    });
    // Product page panel: the suggested questions show once the shopper focuses the panel, and then stay
    // (they stacked 150px high on phones, Guido 10-13). The Ask Primal drawer always shows them.
    if (!root.closest('dialog')) root.addEventListener('focusin', function () { root.classList.add('pw-ask--open'); });
    root._pwAsk = { ask: ask, clear: clear, input: input };
    return root._pwAsk;
  }

  function boot() {
    document.querySelectorAll('[data-pw-ask]').forEach(init);
    var dialog = document.querySelector('[data-pw-ask-dialog]');
    if (!dialog) return;
    var panel = init(dialog.querySelector('[data-pw-ask]'));
    var opener = null;
    dialog.querySelector('[data-pw-ask-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); }); // backdrop
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('pw-ask-open');
      if (opener && document.contains(opener) && opener.getClientRects().length) opener.focus();
    });

    window.pwAsk.open = function (q) {
      opener = document.activeElement;
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('pw-ask-open');
      if (q) { panel.clear(); panel.ask(q); }
      panel.input.focus();
    };

    // "Build me a case" links (cart drawer). The open drawer makes the page inert, so close it first.
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pw-ask-case]');
      if (!a) return;
      e.preventDefault();
      var open = document.querySelector('.sidebar--opened');
      if (open && open.hide) open.hide();
      window.pwAsk.open(a.dataset.pwAskCase);
    });

    // Search bar: an "Ask Primal" row as the first suggestion when the text reads like a question.
    // The theme renders suggestions into [data-js-search-results]; the row joins its keyboard list,
    // and Enter on it navigates to #pw-ask, which opens the assistant.
    var Q = /^(what|which|how|is|are|does|do|can|could|should|would|will|who|why|where|when|recommend|suggest|best|good|need|looking|something|anything|pair|pairs|goes|wine for|gift)\b/i;
    function questionLike(q) {
      if (q.length < 8) return false;
      return /\?$/.test(q) || Q.test(q) || q.split(/\s+/).length >= 5;
    }
    var lastQ = '';
    document.querySelectorAll('search-form').forEach(function (sf) {
      var results = sf.querySelector('[data-js-search-results]');
      var input = sf.querySelector('[data-js-search-input]');
      if (!results || !input) return;
      new MutationObserver(function () {
        var q = input.value.trim();
        if (results.querySelector('.pw-ask-row') || !questionLike(q)) return;
        var row = el('a', 'search-item pw-ask-row');
        row.href = '#pw-ask';
        row.tabIndex = -1;
        row.setAttribute('data-js-search-item', '');
        row.appendChild(el('span', 'pw-ask-row__label', 'Ask Primal'));
        row.appendChild(el('span', 'pw-ask-row__q', q));
        row.addEventListener('click', function (e) { e.preventDefault(); window.pwAsk.open(q); });
        var holder = results.querySelector('[data-js-search-results-holder]') || results;
        holder.insertBefore(row, holder.firstChild);
        lastQ = q;
        sf.results = results.querySelectorAll('[data-js-search-item]'); // keep the theme's arrow-key list in sync
      }).observe(results, { childList: true, subtree: true });
    });
    window.addEventListener('hashchange', function () {
      if (location.hash !== '#pw-ask') return;
      history.replaceState(null, '', location.pathname + location.search);
      window.pwAsk.open(lastQ);
    });
  }

  window.pwAsk = { open: function () {} };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
